module.exports = __webpack_public_path__ + "static/img/medal1.4fe381a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/5/medal1.png
// module id = 8d2L
// module chunks = 1